import permissions from '../permissions'

const COMPANY_SUPPLIER_QUESTIONNAIRES_RECEIVED_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.COMPANY_SUPPLIER_QUESTIONNAIRES_RECEIVED.MANAGE,
  },
]

export default COMPANY_SUPPLIER_QUESTIONNAIRES_RECEIVED_LIST
